<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-grid">
        <div>
          <h4 class="footer-title">Navigate</h4>
          <ul class="link-list">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link to="/beats">Beats</router-link></li>
            <li><router-link to="/collab">Mix &amp; Master</router-link></li>
            <li><router-link to="/profile">Profile</router-link></li>
          </ul>
        </div>
        <div>
          <h4 class="footer-title">Contact</h4>
          <ul class="link-list">
            <li>Phone &amp; WhatsApp: <a href="tel:+254707232844">+254-707-232844</a></li>
            <li>Email: <a href="mailto:bysonicsounds@gmail.com">bysonicsounds@gmail.com</a></li>
            <li>
              <address>Gate A, Juja, Juja Town<br/>Kiambu County, Kenya</address>
            </li>
          </ul>
        </div>
        <div class="follow-col">
          <h4 class="footer-title">Follow Us</h4>
          <div class="social-icons">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" class="social-link facebook" aria-label="Facebook">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" class="social-link twitter" aria-label="Twitter">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" class="social-link instagram" aria-label="Instagram">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
            </a>
          </div>
        </div>
      </div>
      <div class="footer-divider"></div>
      <div class="footer-legal">
        <router-link to="/terms">Terms of Service</router-link>
        <span class="sep">·</span>
        <router-link to="/privacy">Privacy Policy</router-link>
        <span class="sep">·</span>
        <router-link to="/data-deletion">Data Deletion</router-link>
      </div>
      <p class="footer-copy">&copy; BySonic, {{ currentYear }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FootSection',
  data: function () {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.site-footer {
  background: #050505;
  border-top: 1px solid rgba(201,168,76,0.1);
  padding: 50px 40px 30px;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.follow-col {
  text-align: center;
}

@media (max-width: 600px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
}

.footer-title {
  font-family: 'Cinzel', serif;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--gold-mid);
  margin-bottom: 16px;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0 0 30px;

  li {
    font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    font-weight: 300;
    color: #555;
    margin-bottom: 8px;
    letter-spacing: 0.05em;
  }

  a {
    color: #555;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: var(--gold-light);
    }
  }

  address {
    font-style: normal;
    display: inline;
  }
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 8px;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.03);
  transition: all 0.3s;

  &.facebook {
    color: #1877F2;
    &:hover {
      background: rgba(24,119,242,0.15);
      box-shadow: 0 0 14px rgba(24,119,242,0.4);
    }
  }

  &.twitter {
    color: #1DA1F2;
    &:hover {
      background: rgba(29,161,242,0.15);
      box-shadow: 0 0 14px rgba(29,161,242,0.4);
    }
  }

  &.instagram {
    color: #E4405F;
    &:hover {
      background: rgba(228,64,95,0.15);
      box-shadow: 0 0 14px rgba(228,64,95,0.4);
    }
  }
}

.footer-divider {
  width: 60px;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--gold-deep), transparent);
  margin: 20px auto;
}

.footer-legal {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;

  a {
    font-family: 'Montserrat', sans-serif;
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #444;
    text-decoration: none;
    transition: color 0.3s;

    &:hover {
      color: var(--gold-light);
    }
  }

  .sep {
    font-size: 9px;
    color: #333;
  }
}

.footer-copy {
  font-family: 'Montserrat', sans-serif;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: #333;
  text-align: center;
  margin: 0;
}
</style>
